import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { TIER_LINES, PRICING_LEAD, COMPLIANCE_TEXT, CONSULTING_TEXT } from "@/config/pricingText";

export default function HomePricing() {
  return (
    <section id="pricing" className="bg-wash py-[88px] scroll-mt-16">
      <div className="mx-auto max-w-[1160px] px-6">
        <Chapter
          eyebrow="Pricing"
          title="Simple, per-site, in writing."
          lede={PRICING_LEAD}
        />
        <div className="grid md:grid-cols-3 gap-5 mb-5">
          {TIER_LINES.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1} className="h-full">
              <div
                data-testid={`home-pricing-${t.name.toLowerCase()}`}
                className={`h-full bg-white rounded-[14px] p-8 shadow-[0_2px_10px_rgba(23,71,95,0.05)] ${
                  t.name === "Pro" ? "border-2 border-safety" : "border border-line"
                }`}
              >
                <h3 className="text-2xl font-extrabold text-navy mb-4">{t.name}</h3>
                <p className="text-sm text-ink leading-relaxed">{t.line}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div
            data-testid="home-pricing-pilot"
            className="bg-hi rounded-[14px] p-8 mb-5 flex flex-wrap items-center justify-between gap-4"
          >
            <p className="text-lg font-extrabold text-navydeep">Founding paid pilot: $1,000, no install fee.</p>
            <a
              href="/contact?topic=pilot"
              data-testid="home-pricing-pilot-cta"
              className="rounded-lg bg-navydeep text-white font-bold px-6 py-3 hover:bg-navy transition-colors"
            >
              Book a pilot
            </a>
          </div>
        </Reveal>
        <div className="space-y-4">
          <Reveal delay={0.2}>
            <p data-testid="home-pricing-compliance" className="bg-white border border-line rounded-[14px] p-6 text-sm text-steel leading-relaxed">
              <strong className="text-navy">Compliance Evaluation &amp; Documentation Service:</strong> {COMPLIANCE_TEXT}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p data-testid="home-pricing-consulting" className="bg-white border border-line rounded-[14px] p-6 text-sm text-steel leading-relaxed">
              <strong className="text-navy">Consulting:</strong> {CONSULTING_TEXT}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
